import React, { useState } from 'react'
import child from "../assets/login-icons/child.png"
import axios from 'axios'
import { API } from './constant'

import { ToastContainer, toast } from 'react-toastify';
import "react-toastify/dist/ReactToastify.css";

const Login = () => {



  const [Email, setEmail] = useState("")
  const [Password, setPassword] = useState("")
  const [viewPassword, setviewPassword] = useState(false)

  // login start 
  const HandleLogin = async () => {
    const data = {
      email: Email,
      password: Password
    }
    await axios.post(`${API}/login`, data)
      .then((res) => {
        console.log(res.data)
        localStorage.setItem("token", res.data.token)
        toast.success(res.data.message)
        setTimeout(() => {
          window.location.href = "/students"
        }, 3000);
      })
      .catch((error) => {
        console.log(error)

        // check if the error is rate limit error 
        const errorMessage=
        error.response?.status===429?error.response.data:error.response.data.message
        // alert(error.response.data.message)
        toast.warning(errorMessage, { theme: "colored" })
      })
  }
  // login end

  // onkeypress enter key start 
  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      HandleLogin()
    }
  }
  // onkeypress enter key end




  return (
    <div>
      <div className='bg-theme_yellow_dark  w-full h-screen relative '>
        <ToastContainer position="top-right" autoClose={3000} />
        <div className='flex  ml-[200px]'>
          <div className='mt-[150px]'>
            <h1 className='text-theme_white'>🎒 Welcome to Little Learners Hub</h1>
            <p className='text-theme_white '>Please log in to manage and view student data for Class 1 and 2. Your gateway to nurturing young minds starts here!</p>
          </div>
        </div>

        <div className='flex w-full '>
          <div className='left_container w-[50%] ml-[200px] mt-[100px]'>
            <div className='bg-theme_yellow_dark_transparent p-[20px] w-[50%] rounded-3xl'>

              <div className='mt-[30px]'>
                <div>
                  {/* <label htmlFor="">Email:</label> */}
                </div>
                <input value={Email} onChange={(e) => setEmail(e.target.value)} type="email" className='bg-theme_white px-[20px] py-[10px] w-full rounded-3xl' placeholder='Email' />
              </div>
              <div className='mt-[30px]'>
                <div>
                  {/* <label htmlFor="">Password:</label> */}
                </div>
                <input onKeyDown={handleKeyPress} value={Password} onChange={(e) => setPassword(e.target.value)} type="password" className='bg-theme_white px-[20px] py-[10px] w-full rounded-3xl' placeholder='Password' />
              </div>

              <div className='my-[30px]'>
                <button onClick={HandleLogin} className='bg-theme_white px-[30px] py-[10px] rounded-3xl'>Login</button>
              </div>

            </div>


          </div>

          <div className='right_container w-[50%] absolute bottom-0 right-0'>
            <img src={child} alt="login child image" />
          </div>
        </div>
      </div>
    </div>
  )
}

export default Login